
import { z } from "zod";

export const mentorSchema = z.object({
  full_name: z.string().min(2, "Name must be at least 2 characters"),
  title: z.string().min(2, "Title must be at least 2 characters"),
  company: z.string().min(2, "Company name must be at least 2 characters"),
  experience_years: z.string().min(1, "Please select years of experience"),
  bio: z.string().min(20, "Bio must be at least 20 characters"),
  expertise: z.string().min(5, "Please list your areas of expertise"),
  availability: z.string().min(5, "Please specify your availability"),
  beta_tester: z.boolean().default(false),
  calendly_url: z.string().url("Must be a valid URL").optional().or(z.literal("")),
});

export type MentorFormValues = z.infer<typeof mentorSchema>;
